<template>
    <div></div>
</template>

<script>
export default {
  name: 'ModuleUpdateEntity'
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdateEntity.vue